import PropTypes from "prop-types";

function SectionLabel({ label }) {
    return (
        <div className="tta-section-label liner-light-blue-background">
            <span>{label}</span>
        </div>
    );
}

SectionLabel.propTypes = {
    label: PropTypes.string,
};

export default SectionLabel;
